import { render, staticRenderFns } from "./BundlePackageForm.vue?vue&type=template&id=3b724758&"
import script from "./BundlePackageForm.vue?vue&type=script&lang=js&"
export * from "./BundlePackageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports